<template>
  <div class="">
    <!-- <Page :title="pageTitle"> -->
    <ChatContentExtension />
    <!-- </Page> -->
  </div>
</template>

<script>
// import Page from "../components/Common/Page.vue";

import ChatContentExtension from "../components/Common/ChatContentExtension";
export default {
  name: "CRM",
  components: {
    ChatContentExtension
    // Page
  },
  data() {
    return {
      pageTitle: "Whatsapp CRM"
    };
  }
};
</script>

<style lang="scss" scoped></style>
